import { Layout } from "../components"

const posts = [
  {
    title: 'Training Intelligent Investigasi',
    href: '#',
    description: "Pada dasarnya kejahatan tidak dapat dimusnahkan, sulit diprediksi, namun dengan SDM, design dan menejemen keamanan yang Tangguh akan mampu mendeteksi, mencegah gangguan Keamanan &amp; Kejahatan seperti Pencurian, Pemalsuan, Curang, Manipulasi dan Korupsi.",
    imageUrl: 'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
  },
  {
    title: 'Grafonomy Training',
    href: '#',
    description: 'Nilai Informasi penting tulisan dan tanda tangan dalam dokumen sering menimbulkan masalah hukum dan ekonomi. Industri keuangan, institusi, penegak hukum dan perorangan perlu mengetahui detail tentang karakteristik pencurian dan manipulasi dengan cara memalsukan dokumen dan tanda tangan sehingga kerugian secara ekonomi, nama baik dan kredibilitas Perusahaan serta Pejabatnya terlindungi.',
    imageUrl: 'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
  },
  {
    title: 'Fraud Training',
    href: '#',
    description: 'Ketersediaan Sumber daya Manusia (SDM) yang kompeten dalam pencegahan, deteksi dini, investigasi, Audit internal dan pengawasan internal atas perbuatan curang, pencurian, korupsi, manipulasi dan konflik interest jajaran menejemen, karyawan merupakan holes dan peluang perlu Fraud Control.',
    imageUrl: 'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
  },
  {
    title: 'Intelligent System Security Training',
    href: '#',
    description: 'Kejahatan, konflik kepentingan, perbuatan anarkis, terorisme, unjuk rasa/demontrasi, kerusuhan masal dan tindak pidana dapat terjadi kapan saja tidak dapat diduga. Peristiwa tersebut dapat mengancam keseimbangan, keselamatan jiwa dan kerugian materi yang nilainya dan kapan terjadinya tidak dapat diprediksi. Diperlukan sumber daya guna Deteksi dini, preventif, dan represif untuk protect, menekan, meniadakan dan melakukan tindakan terukur yang dapat memungkinkan oprasional perusahaan tidak terganggu.',
    imageUrl: 'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
  },
]

export default function Product () {
  return (
    <Layout>
      <div className="relative bg-gray-900 pt-10 pb-20 px-4 sm:px-6 lg:pb-28 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-gray-900 h-1/3 sm:h-2/3" />
        </div>
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl tracking-tight font-extrabold text-white sm:text-4xl">Produk</h2>
            {/* <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
              Produk dan jasa yang tersedia
            </p> */}
          </div>
          <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
            {posts.map((post, i) => (
              <div key={i} className="flex flex-col rounded-lg shadow-lg overflow-hidden">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src={post.imageUrl} alt="" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <a href={post.href} className="block mt-2">
                      <p className="text-xl font-semibold text-gray-900">{post.title}</p>
                      <p className="mt-3 text-sm text-gray-500 text-justify">{post.description}</p>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
